import { postApi } from '../api/digitalVault';
import { parseContents } from '../utils/parseContents';
export default async (checksums, logger) => {
    const query = new URLSearchParams();
    checksums.forEach((s) => query.append('checksum', s.toString()));
    const contentQueryResponse = await postApi(query, `content/query`, {}, logger);
    return parseContents(contentQueryResponse);
};
